import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../../FaIcon';
import {BUSummaryRow} from './BUSummaryRow';

const BU_PREVIEW_LIMIT = 5;

// `showMediaPlanCta` (ficha v2, D6-discovery): el empty state ofrece los DOS caminos — crear a
// mano o conectar el media plan — en el momento de máxima receptividad (el usuario está por
// hacer a mano lo que la feature automatiza).
export function BUSummaryBox({businessUnits, clientId, onAddBU, showMediaPlanCta = false}) {
    const {t} = useTranslation();

    const activeBUs = (businessUnits || []).filter(
        bu => bu.active === true && bu.is_eventual_and_it_is_finished !== true
    );

    const displayBUs = activeBUs.slice(0, BU_PREVIEW_LIMIT);
    const remainingCount = activeBUs.length - displayBUs.length;

    return (
        <div className="box bu-summary-box">
            <div className="bu-summary-header">
                <h3 className="bu-summary-title">
                    {t('control_central.bu_summary_title')}
                    <span>({activeBUs.length})</span>
                </h3>
                <Link className="bu-summary-link" to={`/client/${clientId}/monitoring`}>
                    {t('control_central.bu_summary_see_all')} &rarr;
                </Link>
            </div>
            {activeBUs.length > 0 ? (
                <>
                    <table className="bu-summary-table">
                        <tbody>
                        {displayBUs.map(bu => (
                            <BUSummaryRow key={bu.id} bu={bu}/>
                        ))}
                        </tbody>
                    </table>
                    {remainingCount > 0 && (
                        <div className="bu-summary-more">
                            <Link to={`/client/${clientId}/monitoring`}>
                                {t('control_central.bu_more_count', {count: remainingCount})}
                            </Link>
                        </div>
                    )}
                </>
            ) : showMediaPlanCta ? (
                <div className="cc-empty-state bu-empty-dual">
                    <FaIcon iconName="chart-line"/>
                    <p>{t('control_central.bu_no_budget')}</p>
                    <div className="bu-empty-paths">
                        <div className="bu-empty-path">
                            <h5>{t('control_central.bu_empty_manual_title')}</h5>
                            <p>{t('control_central.bu_empty_manual_text')}</p>
                            <button className="btn -negative -small" onClick={onAddBU}>
                                {t('control_central.bu_empty_cta')}
                            </button>
                        </div>
                        <div className="bu-empty-path -highlight">
                            <h5>{t('control_central.bu_empty_plan_title')}</h5>
                            <p>{t('control_central.bu_empty_plan_text')}</p>
                            <Link className="btn -alt -small" to={`/client/${clientId}/media-plan`}>
                                {t('control_central.bu_empty_plan_cta')}
                            </Link>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="cc-empty-state">
                    <FaIcon iconName="chart-line"/>
                    <p>{t('control_central.bu_no_budget')}</p>
                    <button className="btn -alt -small" onClick={onAddBU}>
                        <FaIcon iconName="plus"/>
                        {t('control_central.bu_empty_cta')}
                    </button>
                </div>
            )}
        </div>
    );
}
